import type { FeatureLike } from "ol/Feature";
import type { MapBrowserEvent } from "ol";
import type { Coordinate } from "ol/coordinate";
import { MapClick } from "../../../../reactOL/interactions";
import type { RouteLineSummary } from "../RouteLineSummary";

interface RouteLineMapClickProps {
  active: boolean;
  onSelect: (summaries: RouteLineSummary[], coordinate: Coordinate) => void;
}

const toRouteLineSummary = (feature: FeatureLike): RouteLineSummary | null => {
  const id = feature.get("id");
  const operatorName = feature.get("operatorName");
  const serviceNumber = feature.get("serviceNumber");

  if (id == null || operatorName == null || serviceNumber == null) return null;

  return {
    id: Number(id),
    operatorName: String(operatorName),
    serviceNumber: String(serviceNumber),
  };
};

const RouteLineMapClick = ({ active, onSelect }: RouteLineMapClickProps) => {
  const onClick = (features: FeatureLike[], e: MapBrowserEvent<any>) => {
    const summaries = features
      .map(toRouteLineSummary)
      .filter((s): s is RouteLineSummary => s !== null);

    if (summaries.length > 0) {
      onSelect(summaries, e.coordinate);
    }
  };

  return <MapClick active={active} onClick={onClick} hitTolerance={5} />;
};

export default RouteLineMapClick;
